import React, { Fragment } from "react";
import SliderWithPercent from "./../sliderWithPercent";
import CircleRectIcon from "./circleRectIcon";

const regex = /([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\:\&\s])/g;

const AssetClassGroup = ({
  asset_class_validated_data,
  resetRangeSlider,
  activePortfolioID,
  slider_colors,
  minMaxZeroToHundred,
  sliderDisplayHandler,
  getChar,
  sliderRangeHandler,
  displayRangeSlider,
  exclamation_warning,
  getScenarioShortlist,
}) => {
  return (
    <Fragment>
      <div className="BuildPortfolio_holder_assetClass_heading">
        Asset Class :
      </div>
      <div className="BuildPortfolio_holder_assetClass_pills">
        {(asset_class_validated_data &&
          asset_class_validated_data.length > 0 &&
          resetRangeSlider) ||
          (asset_class_validated_data &&
            asset_class_validated_data.length > 0 &&
            asset_class_validated_data.map(
              (el, i) =>
                (asset_class_validated_data.length === 2 &&
                asset_class_validated_data.filter(
                  (ob) => ob.name.toLowerCase() === "cash"
                ).length === 1
                  ? el
                  : el) && (
                  // el.name.toLocaleLowerCase() !== "cash"

                  <div
                    key={el.name}
                    onClick={(e) =>
                      sliderDisplayHandler(
                        e,
                        `${el.name.replace(
                          regex,
                          ""
                        )}-asset-class-${i}-${activePortfolioID}`
                      )
                    }
                  >
                    <CircleRectIcon
                      fullLabel={el.name}
                      label={getChar({ sentence: el.name })}
                      color={
                        el.name.toLowerCase() === "cash"
                          ? "#008635"
                          : slider_colors[i]
                      }
                      min={el.min * 100}
                      max={el.max * 100}
                      steps={el.name.toLowerCase() === "cash" ? 0.1 : 1}
                      // max={el.max * 100}
                      bg_warning={el.slider_error}
                      // handler={(e) => sliderDisplayHandler(e)}
                      cursor={
                        displayRangeSlider === false ? "default" : "pointer"
                      }
                      exclamation_warning={
                        exclamation_warning &&
                        getScenarioShortlist.filter(
                          (obj) => obj["fund_asset_class_focus"] === el.name
                        ).length > 0
                          ? false
                          : true
                      }
                    />
                    {displayRangeSlider === false ? null : (
                      <div
                        className="BuildPortfolio_holder_assetClass_pills__popup"
                        id={`${el.name.replace(
                          regex,
                          ""
                        )}-asset-class-${i}-${activePortfolioID}`}
                      >
                        <span className="BuildPortfolio_holder_assetClass_pills__popup_popuptext ">
                          {el.min && el.max ? (
                            <SliderWithPercent
                              min={el.min * 100}
                              max={el.max * 100}
                              steps={el.name.toLowerCase() === "cash" ? 0.1 : 1}
                              minMaxZeroToHundred={minMaxZeroToHundred}
                              ID={`${el.name.replace(
                                regex,
                                ""
                              )}-asset-slider-${activePortfolioID}`}
                              // its asset_class
                              group="overall_focus"
                              name={el.name}
                              Sliderhandler={(obj) => sliderRangeHandler(obj)}
                              bg_warning={el.slider_error}
                            />
                          ) : null}
                        </span>
                      </div>
                    )}
                  </div>
                )
            ))}
      </div>
    </Fragment>
  );
};

export default AssetClassGroup;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/AssetClassGroup.jsx